import {
  css,
  createGlobalStyle,
  ThemedCssFunction,
  CSSObject,
} from 'styled-components';

const variables = css`
  :root {
    --color-primary: #6c6fff;
  }

  ._dark {
    --color-primary: #40a3ff;
    --color-primary-gradient: linear-gradient(90deg, #c669ff 0%, #7555f7 100%);
  }
`;

const Variables = createGlobalStyle`${variables}`;

export default Variables;
